<template>
  <div>
    <div v-if="!isTablet">
      <Header />
      <TitlePage />
      <div class="content-payment">
        <b-container fluid="xl">
          <b-row v-if="userPayment != null">
            <b-col cols="12" class="pd-lr-7">
              <div class="title-payment">{{$t('payment.title')}}</div>
              <div class="line-bottom"></div>
            </b-col>
            <b-col cols="4" class="content-left">
              <b-list-group>
                <b-list-group-item class="d-flex align-items-center bg-green">
                  <div class="d-flex w-100 justify-content-center align-items-center">
                    <div class="order-summary">{{$t('payment.orderSummary')}}</div>
                  </div>
                </b-list-group-item>

                <!-- List of listing packages. Desktop -->
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="packageListing in packagesListings"
                  :key="packageListing.packages_detail.id"
                >
                  <div class="name-order">
                    <div
                      style="float:left;margin-right:2px;"
                      @click="removeListingPackage(packageListing.id)"
                      v-if="(!disablePayment && packagesListings.length > 1) || !loading"
                    >
                      <TrashIcon
                        v-if="(!disablePayment && packagesListings.length > 1) || !loading"
                      />
                    </div>
                    {{ $t(packageListing.packages_detail.package.name)}}
                  </div>
                  <div
                    class="term-and-price"
                  >{{ packageListing.num_days }} {{$t('days')}} - {{ parseFloat(packageListing.price).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>

                <!-- List of general packages. Desktop -->
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="detail in packagesGeneral"
                  :key="detail.id"
                >
                  <div class="name-order">
                    <div
                      style="float:left;margin-right:2px;"
                      @click="removeGeneralPackage(detail.id)"
                      v-if="(!disablePayment && packagesGeneral.length > 1) || !loading"
                    >
                      <TrashIcon v-if="(!disablePayment && packagesGeneral.length > 1) || !loading" />
                    </div>
                    {{ $t(detail.package_general.name) }}
                  </div>
                  <div class="term-and-price">{{ parseFloat(detail.price).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>

               

                <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green text-white"
                >
                  <div class="name-order text-white">{{$t('payment.sevenVat')}}</div>
                  <div
                    class="term-and-price text-white"
                  >{{parseFloat(userPayment.vat).toLocaleString("th-TH")}} {{ $t('payment.baht') }}</div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green"
                >
                  <div class="name-order text-white">{{$t('payment.serviceFee')}}</div>
                  <div
                    class="term-and-price text-white"
                  >{{ parseFloat(userPayment.payment_fee).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                </b-list-group-item>
                 <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green text-white"
                  v-if="userPayment.discount > 0 || (hotDealCodeId && userPayment.discount_code_id)"
                >
                  <div class="name-order text-white">{{$t('payment.discount')}}</div>
                  <div
                    class="term-and-price text-white" v-if="hotDealCodeId == userPayment.discount_code_id"
                  >{{ $t('payment.hotDealApplied') }}</div>
                  <div
                    class="term-and-price text-white" v-else
                  >- {{parseFloat(userPayment.discount).toLocaleString("th-TH")}} {{ $t('payment.baht') }}</div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green text-white"
                  v-if="(userPayment.discount > 0 || (hotDealCodeId && userPayment.discount_code_id)) && !disablePayment"
                >
                
                  <div class="text-white">
                     <b-spinner v-if="loading" label="Loading..." variant="light"></b-spinner>
                    <a
                      id="updateUserPayment"
                      v-else
                      @click="updateUserPayment(true, activePaymentMethod)"
                      style="text-decoration: underline;font-weight: 100 !important;font-size: 12px;cursor: pointer;"
                    >{{ $t('payment.useDiscountLater') }}</a>
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green text-white"
                  v-else-if="!disablePayment"
                >
                  <div class="name-order text-white">
                    <b-form-input
                      :disabled="loading"
                      class="input-discount-code"
                      :placeholder="$t('payment.discountCode')"
                      v-model="discountCode"
                    ></b-form-input>
                  </div>
                  <div class="term-and-price text-white">
                    <b-spinner v-if="loading" label="Loading..." variant="light"></b-spinner>
                    <b-button
                      v-else
                      id="updateUserPayment"
                      class="btn-discount-code"
                      @click="updateUserPayment(false, activePaymentMethod)"
                    >{{ $t('payment.useDiscount') }}</b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center bg-green"
                >
                  <div class="name-order text-white">{{$t('payment.total')}}</div>
                  <div
                    class="term-and-price text-white"
                  >{{ parseFloat(userPayment.total_amount).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                </b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col cols="8" class="content-right">
              <b-tabs class="tabs-payment" v-if="hotDealCodeId != null && hotDealCodeId != userPayment.discount_code_id">
                <HotDeal
                  :orderId="userPayment.id"
                  :formattedAmount="userPayment.total_amount"
                  :invalidDiscountCode="invalidDiscountCode"
                  :changeLoading="changeLoading"
                  :loading="loading"
                  :paymentDiscountCode="userPayment.discount_code_id"
                  :hotDealDiscountCode="hotDealCodeId"
                  :previousPendingPaymentId="previousPendingPaymentId"
                  :listingId="userPayment.listing_id"
                />
              </b-tabs>
              <b-tabs class="tabs-payment" v-else-if="userPayment.total_amount == 0">
                <Free
                  :orderId="userPayment.id"
                  :formattedAmount="userPayment.total_amount"
                  :changeLoading="changeLoading"
                  :loading="loading"
                  :previousPendingPaymentId="previousPendingPaymentId"
                />
              </b-tabs>
              <b-tabs class="tabs-payment" v-else>
                <b-container fluid="md">
                  <b-row v-if="disablePayment">{{disableMessage}}</b-row>
                </b-container>
                <b-tab
                  :active="activePaymentMethod === card_payment"
                  @click="tabActive(card_payment)"
                  :disabled="disablePayment || (loading && activePaymentMethod !== card_payment) || disablePayments.includes(card_payment)"
                >
                  <template v-slot:title>
                    <CreditCardIcon />
                    <span>{{$t('payment.methods.creditCard.title')}}</span>
                  </template>
                  <div class="tab-credit-card">
                    <b-container fluid="md" v-if="loading">
                      <div class="text-center">
                        <b-spinner label="Loading..." variant="'primary'"></b-spinner>
                      </div>
                    </b-container>
                    <CreditCard
                      v-else
                      :orderId="userPayment.id"
                      :formattedAmount="formattedAmount"
                      :changeLoading="changeLoading"
                      :previousPendingPaymentId="previousPendingPaymentId"
                    />
                  </div>
                </b-tab>
                <b-tab
                  :active="activePaymentMethod === paypal_payment"
                  @click="tabActive(paypal_payment)"
                  :disabled="disablePayment || (loading && activePaymentMethod !== paypal_payment) || disablePayments.includes(paypal_payment)"
                >
                  <template v-slot:title>
                    <PaypalIcon />
                    <span>{{$t('payment.methods.paypal.title')}}</span>
                  </template>
                  <div class="tab-paypal">
                    <b-container fluid="md" v-if="loading">
                      <div class="text-center">
                        <b-spinner label="Loading..." variant="'primary'"></b-spinner>
                      </div>
                    </b-container>
                    <PayPal
                      v-else
                      :orderId="userPayment.id"
                      :formattedAmount="formattedAmount"
                      :changeLoading="changeLoading"
                      :previousPendingPaymentId="previousPendingPaymentId"
                    />
                  </div>
                </b-tab>
                <b-tab
                  :active="activePaymentMethod === banking_payment"
                  @click="tabActive(banking_payment)"
                  :disabled="disablePayment || (loading && activePaymentMethod !== banking_payment) || disablePayments.includes(banking_payment)"
                >
                  <template v-slot:title>
                    <BankIcon />
                    <span>{{$t('payment.methods.directDebit.title')}}</span>
                  </template>
                  <div class="tab-debit">
                    <b-container fluid="md" v-if="loading">
                      <div class="text-center">
                        <b-spinner label="Loading..." variant="'primary'"></b-spinner>
                      </div>
                    </b-container>
                    <OnlineBanking
                      v-else
                      :orderId="userPayment.id"
                      :formattedAmount="formattedAmount"
                      :changeLoading="changeLoading"
                      :previousPendingPaymentId="previousPendingPaymentId"
                    />
                  </div>
                </b-tab>
                <b-tab
                  :active="activePaymentMethod === coin_payment"
                  @click="tabActive(coin_payment)"
                  :disabled="disablePayment || packagesGeneral.length > 0 || (loading && activePaymentMethod !== coin_payment) || disablePayments.includes(coin_payment)"
                >
                  <template v-slot:title>
                    <span class="mif-coins"></span>
                    <span>{{$t('payment.methods.khaosodCoin.title')}}</span>
                  </template>
                  <div class="tab-coin mb-3">
                    <b-container fluid="md" v-if="loading">
                      <div class="text-center">
                        <b-spinner label="Loading..." variant="'primary'"></b-spinner>
                      </div>
                    </b-container>
                    <Coins
                      v-else
                      :orderId="userPayment.id"
                      :formattedAmount="formattedAmount"
                      :availableCoins="parseFloat(userPayment.user.coin)"
                      :amount="parseFloat(userPayment.total_amount)"
                      :changeLoading="changeLoading"
                      :previousPendingPaymentId="previousPendingPaymentId"
                    />
                  </div>
                </b-tab>
                <b-tab
                  :active="activePaymentMethod === bill_payment || activePaymentMethod === true_money || activePaymentMethod === prompt_pay"
                  :disabled="disablePayment || (loading && activePaymentMethod !== bill_payment && activePaymentMethod !== true_money && activePaymentMethod !== prompt_pay)
                  || (disablePayments.includes(bill_payment) && disablePayments.includes(true_money) && disablePayments.includes(prompt_pay))"
                >
                  <template v-slot:title>
                    <WalletIcon />
                    <span>{{$t('payment.other')}}</span>
                  </template>
                  <div class="tab-counter">
                    <b-container fluid="md" v-if="loading">
                      <div class="text-center">
                        <b-spinner label="Loading..." variant="'primary'"></b-spinner>
                      </div>
                    </b-container>
                    <Others
                      v-else
                      :updatePaymentMethod="tabActive"
                      :orderId="userPayment.id"
                      :formattedAmount="formattedAmount"
                      :changeLoading="changeLoading"
                      :previousPendingPaymentId="previousPendingPaymentId"
                      :preSelectedMethod="activePaymentMethod"
                      :disablePayments="disablePayments"
                    />
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <Footer :adsFooter="adsFooter"/>
    </div>
    <div v-if="isTablet">
      <Header currentPage="payment" />
      <div class="mobile-content-payment">
        <b-container fluid="xl">
          <b-row v-if="!isShowPaymentDetail">
            <b-col cols="12">
              <div class="choose-type-payment">
                <div class="title">{{$t('payment.paymentMethods')}}</div>
                <div class="wrap-payment">
                  <div
                    :active="activePaymentMethod === card_payment"
                    @click="tabActive(card_payment)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== card_payment) || disablePayments.includes(card_payment)"
                    class="wrap-credit-card item"
                    v-bind:class="{'active': activePaymentMethod === card_payment}"
                  >
                    <div v-if="activePaymentMethod === card_payment" class="active-circle"></div>
                    <CreditCardIcon />
                    <div class="text">{{$t('payment.methods.creditCard.title')}}</div>
                  </div>
                  <div
                    class="wrap-paypal item"
                    :active="activePaymentMethod === paypal_payment"
                    @click="tabActive(paypal_payment)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== paypal_payment) || disablePayments.includes(paypal_payment)"
                    v-bind:class="{'active': activePaymentMethod === paypal_payment}"
                  >
                    <div v-if="activePaymentMethod === paypal_payment" class="active-circle"></div>
                    <PaypalIcon />
                    <div class="text">{{$t('payment.methods.paypal.title')}}</div>
                  </div>
                  <div
                    class="wrap-debit item"
                    :active="activePaymentMethod === banking_payment"
                    @click="tabActive(banking_payment)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== banking_payment) || disablePayments.includes(banking_payment)"
                    v-bind:class="{'active': activePaymentMethod === banking_payment}"
                  >
                    <div v-if="activePaymentMethod === banking_payment" class="active-circle"></div>
                    <BankIcon />
                    <div class="text">{{$t('payment.methods.directDebit.title')}}</div>
                  </div>
                  <div
                    class="wrap-counter-bill item"
                    :active="activePaymentMethod === true_money"
                    @click="tabActive(true_money)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== true_money) || disablePayments.includes(true_money)"
                    v-bind:class="{'active': activePaymentMethod === true_money}"
                  >
                    <div v-if="activePaymentMethod === true_money" class="active-circle"></div>
                    <b-img src="/images/trueMoney.png" class="logo-item"  :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                    <!-- <div class="text">{{$t('payment.methods.payOverCounter.title')}}</div> -->
                  </div>
                  <div
                    class="wrap-counter-bill item"
                    :active="activePaymentMethod === bill_payment"
                    @click="tabActive(bill_payment)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== bill_payment) || disablePayments.includes(bill_payment)"
                    v-bind:class="{'active': activePaymentMethod === bill_payment}"
                  >
                    <div v-if="activePaymentMethod === bill_payment" class="active-circle"></div>
                    <b-img src="/images/tescoLotus.png" class="logo-item"  :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                    <!-- <div class="text">{{$t('payment.methods.payOverCounter.title')}}</div> -->
                  </div>
                  <div
                    class="wrap-counter-bill item"
                    :active="activePaymentMethod === prompt_pay"
                    @click="tabActive(prompt_pay)"
                    :disabled="disablePayment || (loading && activePaymentMethod !== prompt_pay) || disablePayments.includes(prompt_pay)"
                    v-bind:class="{'active': activePaymentMethod === prompt_pay}"
                  >
                    <div v-if="activePaymentMethod === prompt_pay" class="active-circle"></div>
                    <b-img src="/images/promptPay.png" class="logo-item"  :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"></b-img>
                    <!-- <div class="text">{{$t('payment.methods.payOverCounter.title')}}</div> -->
                  </div>
                  <div class="wrap-coins item">
                    <span class="mif-coins"></span>
                    <div class="text">{{$t('payment.methods.khaosodCoin.title')}}</div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="wrap-payment-confirm">
                <div class="wrap-btn">
                  <b-spinner v-if="loading" label="Loading..." variant="success"></b-spinner>
                  <b-button
                    v-else
                    id="paymentDetail"
                    class="btn-payment success-button"
                    @click="showPaymentDetail"
                  >{{$t('next')}}</b-button>
                </div>
                <b-img src="/images/secured.png" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="isShowPaymentDetail && !isCheckout">
            <b-col cols="12">
              <b-list-group>
                <b-list-group-item class="d-flex align-items-center">
                  <div class="d-flex w-100 justify-content-center align-items-center">
                    <div class="order-summary">{{$t('payment.orderSummary')}}</div>
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="packageListing in packagesListings"
                  :key="packageListing.packages_detail.id"
                >
                  <!-- List of listing packages -->
                  <div class="name-order">
                    <div
                      style="float:left;margin-right:2px;"
                      @click="removeListingPackage(packageListing.id)"
                      v-if="(!disablePayment && packagesListings.length > 1) || !loading"
                    >
                      <TrashIcon />
                    </div>
                    {{ $t(packageListing.packages_detail.package.name)}}
                  </div>
                  <div
                    class="term-and-price"
                  >{{ packageListing.num_days }} {{$t('days')}} - {{ parseFloat(packageListing.price).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>
                <!-- List of coin packages  -->
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-for="detail in packagesGeneral"
                  :key="detail.id"
                >
                  <div class="name-order">
                    <div
                      style="float:left;margin-right:2px;"
                      @click="removeGeneralPackage(detail.id)"
                      v-if="(!disablePayment && packagesGeneral.length > 1) || !loading"
                    >
                      <TrashIcon v-if="(!disablePayment && packagesGeneral.length > 1) || !loading" />
                    </div>
                    {{ $t(detail.package_general.name) }}
                  </div>
                  <div class="term-and-price">{{ parseFloat(detail.price).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>

                

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <div class="name-order">{{$t('payment.sevenVat')}}</div>
                  <div class="term-and-price">{{parseFloat(userPayment.vat).toLocaleString("th-TH")}} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <div class="name-order">{{$t('payment.serviceFee')}}</div>
                  <div class="term-and-price">{{ parseFloat(userPayment.payment_fee).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>
                
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-if="userPayment.discount > 0 || (hotDealCodeId && userPayment.discount_code_id)"
                >
                  <div class="name-order">{{$t('payment.discount')}}</div>
                   <div
                    class="term-and-price" v-if="hotDealCodeId == userPayment.discount_code_id"
                  >{{ $t('payment.hotDealApplied') }}</div>
                  <div class="term-and-price" v-else>- {{parseFloat(userPayment.discount).toLocaleString("th-TH")}} {{ $t('payment.baht') }}</div>
                  <div class="line-bottom"></div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-if="(userPayment.discount > 0 || (hotDealCodeId && userPayment.discount_code_id)) && !disablePayment"
                >
                  <div>
                    <a
                      v-if="!loading"
                      id="updateUserPayment"
                      @click="updateUserPayment(true, activePaymentMethod)"
                      style="text-decoration: underline;font-weight: 100 !important;font-size: 12px;cursor: pointer;"
                    >{{ $t('payment.useDiscountLater') }}</a>
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  v-else-if="!disablePayment"
                >
                  <div class="name-order">
                    <b-form-input
                      :disabled="loading"
                      class="input-discount-code"
                      :placeholder="$t('payment.discountCode')"
                      v-model="discountCode"
                    ></b-form-input>
                  </div>
                  <div class="term-and-price">
                    <b-spinner v-if="loading" label="Loading..." style="color:var(--projectPrimaryColor)"></b-spinner>
                    <b-button
                      v-else
                      class="btn-discount-code"
                      id="updateUserPayment"
                      @click="updateUserPayment(false, activePaymentMethod)"
                    >{{ $t('payment.useDiscount') }}</b-button>
                  </div>
                  <div class="line-bottom"></div>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <div class="name-order">{{$t('payment.total')}}</div>
                  <div
                    class="term-and-price"
                  >{{ parseFloat(userPayment.total_amount).toLocaleString("th-TH") }} {{ $t('payment.baht') }}</div>
                </b-list-group-item>
              </b-list-group>
              <div class="wrap-btn-checkout">
                <b-button
                  class="go-to-checkout success-button"
                  id="goToCheckout"
                  @click="goToCheckout"
                >{{ $t('payment.goToCheckout') }}</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="isCheckout">
            <b-col cols="12">
              <div
                v-if="activePaymentMethod === card_payment && userPayment.total_amount != 0"
                class="checkout-credit-card"
              >
                <b-container fluid="md" v-if="loading">
                  <div class="text-center">
                    <b-spinner label="Loading..." variant="primary"></b-spinner>
                  </div>
                </b-container>
                <CreditCard
                  v-else
                  :orderId="userPayment.id"
                  :formattedAmount="formattedAmount"
                  :changeLoading="changeLoading"
                  :previousPendingPaymentId="previousPendingPaymentId"
                />
              </div>
              <div
                v-if="activePaymentMethod === paypal_payment && userPayment.total_amount != 0"
                class="checkout-paypal text-center"
              >
                <b-container fluid="md" v-if="loading">
                  <div class="text-center">
                    <b-spinner label="Loading..." variant="primary"></b-spinner>
                  </div>
                </b-container>
                <PayPal
                  v-else
                  :orderId="userPayment.id"
                  :formattedAmount="formattedAmount"
                  :changeLoading="changeLoading"
                  :previousPendingPaymentId="previousPendingPaymentId"
                />
              </div>
              <div
                v-if="activePaymentMethod === banking_payment && userPayment.total_amount != 0"
                class="checkout-debit"
              >
                <b-container fluid="md" v-if="loading">
                  <div class="text-center">
                    <b-spinner label="Loading..." variant="primary"></b-spinner>
                  </div>
                </b-container>
                <OnlineBanking
                  v-else
                  :orderId="userPayment.id"
                  :formattedAmount="formattedAmount"
                  :changeLoading="changeLoading"
                  :previousPendingPaymentId="previousPendingPaymentId"
                />
              </div>
              <TrueMoney
                v-if="activePaymentMethod === true_money && userPayment.total_amount != 0"
                :orderId="userPayment.id"
                :formattedAmount="formattedAmount"
                :changeLoading="changeLoading"
                :previousPendingPaymentId="previousPendingPaymentId"
              />
              <CounterBill
                v-if="activePaymentMethod === bill_payment && userPayment.total_amount != 0"
                :orderId="userPayment.id"
                :formattedAmount="formattedAmount"
                :changeLoading="changeLoading"
                :previousPendingPaymentId="previousPendingPaymentId"
              />
              <PromptPay
                v-if="activePaymentMethod === prompt_pay && userPayment.total_amount != 0"
                :orderId="userPayment.id"
                :formattedAmount="formattedAmount"
                :changeLoading="changeLoading"
                :previousPendingPaymentId="previousPendingPaymentId"
                :showQrDialog="false"
              />
              <HotDeal
                  v-if="hotDealCodeId != null && hotDealCodeId != userPayment.discount_code_id"
                  :orderId="userPayment.id"
                  :invalidDiscountCode="invalidDiscountCode"
                  :formattedAmount="userPayment.total_amount"
                  :changeLoading="changeLoading"
                  :loading="loading"
                  :paymentDiscountCode="userPayment.discount_code_id"
                  :hotDealDiscountCode="hotDealCodeId"
                  :previousPendingPaymentId="previousPendingPaymentId"
                  :listingId="userPayment.listing_id"
                />
              <Free
                v-else-if="userPayment.total_amount == 0"
                :orderId="userPayment.id"
                :formattedAmount="userPayment.total_amount"
                :changeLoading="changeLoading"
                :previousPendingPaymentId="previousPendingPaymentId"
                :loading="loading"
                
              />
              
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/ui/header";
import Footer from "@/components/ui/footer";
import TitlePage from "@/components/ui/titlePage";
import CreditCard from "@/components/paymentMethods/creditCard";
import PayPal from "@/components/paymentMethods/payPal";
import Coins from "@/components/paymentMethods/coins";
import OnlineBanking from "@/components/paymentMethods/onlineBanking";
import Others from "@/components/paymentMethods/others";
import CreditCardIcon from "vue-material-design-icons/CreditCardOutline.vue";
import WalletIcon from "vue-material-design-icons/Wallet.vue";
import BankIcon from "vue-material-design-icons/Bank.vue";
import PaypalIcon from "@/components/icons/IconPayPal";
import TrashIcon from "@/components/icons/IconTrash";
import $ from "jquery";
import { mapActions, mapState, mapGetters } from "vuex";
import * as actionType from "@/controllers/ActionTypes";
// import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
// import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";
import CounterBill from "@/components/paymentMethods/others/counterBill";
import PromptPay from "@/components/paymentMethods/others/promptPay";
import TrueMoney from "@/components/paymentMethods/others/trueMoney";
import Free from "@/components/paymentMethods/free";
import HotDeal from "@/components/paymentMethods/hotDeal";

export default {
  name: "payment",
  components: {
    Header,
    Footer,
    TitlePage,
    CreditCardIcon,
    Coins,
    CreditCard,
    PayPal,
    OnlineBanking,
    Others,
    WalletIcon,
    BankIcon,
    PaypalIcon,
    TrashIcon,
    CounterBill,
    PromptPay,
    TrueMoney,
    Free,
    HotDeal
  },
  data() {
    return {
      showTextInSummary: this.$t('payment.viaCreditCard'),
      activePaymentMethod: this.card_payment,
      userPayment: null,
      loading: true,
      disablePayment: false,
      disableMessage: "",
      packagesListings: [],
      packagesGeneral: [],
      discountCode: "",
      choosePaymentMethod: "",
      isShowPaymentDetail: false,
      isCheckout: false,
      otherPaymentMethod: 0,
      disablePayments: [],
      adsFooter: null,
      hotDealCodeId: null,
      invalidDiscountCode: false
    };
  },
  props: {
    id: {
      required: true,
    },
    previousPendingPaymentId: {
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters("UserController", ["isTablet", 'isMobile']),
    ...mapState("PaymentController", [
      "card_payment",
      "banking_payment",
      "bill_payment",
      "paypal_payment",
      "coin_payment",
      "true_money",
      "prompt_pay",
    ]),
    formattedAmount: function () {
      var amount = this.userPayment.total_amount;
      return `${this.$t("payment.pay")} ${parseFloat(amount).toLocaleString("th-TH")} ${this.$t("payment.baht")}`;
    },
  },
  mounted: function () {
    this.fetchUserPayment();
  },
  created(){
    let locationId = 9;
		if(this.isMobile){
			locationId=49;
		}
		this.getFooterAds(locationId);
  },
  methods: {
    ...mapActions("AdsController", [
			"GETADS_FOR_PUBLIC_WEBSITE",
			"CLICK_BANNERADS"
		]),
    ...mapActions("PaymentController", [
      actionType.FETCH_USER_PAYMENT,
      actionType.UPDATE_USER_PAYMENT,
    ]),
    changeLoading(isLoading) {
      this.loading = isLoading;
    },
    fetchUserPayment() {
      var vm = this;
      this.FETCH_USER_PAYMENT({ id: parseInt(this.id) }).then(function (
        result
      ) {
        vm.userPayment = result.data;
        vm.activePaymentMethod = vm.userPayment.payment_method_id;
        vm.checkIfEnablePayment();
        vm.packagesListings =
          vm.userPayment.user_payments_details !== null
            ? vm.userPayment.user_payments_details.filter(function (
                packageListing
              ) {
                return packageListing.packages_detail !== null;
              })
            : [];
        if(vm.userPayment.user_payments_details){
          for (const packageListing of vm.userPayment.user_payments_details) {
            if(packageListing.packages_detail !== null && packageListing.packages_detail.required_discount_code_id != null){
              vm.hotDealCodeId = packageListing.packages_detail.required_discount_code_id;
            }
          }
        }
        vm.packagesGeneral =
          vm.userPayment.user_payments_details !== null
            ? vm.userPayment.user_payments_details.filter(function (
                detail
              ) {
                return detail.package_general !== null;
              })
            : [];
        vm.checkDisabledPayments();
        vm.loading = false;
      });
    },
    checkIfEnablePayment() {
      const now = new Date();
      if (this.userPayment.status === 3) {
        this.disablePayment = true;
        this.disableMessage = this.$i18n.t("payment.orderWasPaid");
      } else if (this.userPayment.expiresAt > now) {
        this.disablePayment = true;
        this.disableMessage = this.$i18n.t("payment.thisOrderHasExpired");
      } else {
        this.disablePayment = false;
        this.disableMessage = null;
      }
    },
    updateUserPayment(removeDiscount, paymentMethod) {
      var vm = this;
      this.loading = true;
      this.UPDATE_USER_PAYMENT({
        id: parseInt(vm.id),
        payment_method: paymentMethod,
        packages: vm.packagesListings.map((a) => a.packages_detail.id),
        discount_code: vm.discountCode,
        remove_discount: removeDiscount === true,
        general_packages: vm.packagesGeneral.map((a) => a.package_general.id),
      })
        .then(function (result) {
          vm.userPayment = result.data;
          vm.checkIfEnablePayment();
          vm.packagesListings =
            vm.userPayment.user_payments_details !== null
              ? vm.userPayment.user_payments_details.filter(function (
                  packageListing
                ) {
                  return packageListing.packages_detail !== null;
                })
              : [];
          vm.packagesGeneral =
            vm.userPayment.user_payments_details !== null
              ? vm.userPayment.user_payments_details.filter(function (
                  detail
                ) {
                  return detail.package_general !== null;
                })
              : [];
          if (removeDiscount === true) {
            vm.discountCode = "";
          }
          vm.loading = false;
        })
        .catch(function (error) {
          vm.loading = false;
          let errorCode = error.data.detail.error;
          vm.invalidDiscountCode = false;
          if (
            errorCode === "DISCOUNT_CODE_NOT_FOUND" ||
            errorCode === "DISCOUNT_CODE_NOT_APPLY"
          ) {
            vm.showError(
              vm.$t("payment.errors.invalidCode"),
              vm.$t("payment.errors.checkDiscountCode")
            );
            vm.invalidDiscountCode = true;
          } else if (errorCode === "DISCOUNT_CODE_MINIMUM_AMOUNT") {
            vm.showError(
              vm.$t("payment.errors.invalidCode"),
              vm.$t("payment.errors.minimumAmount")
            );
            vm.invalidDiscountCode = true;
          } else if (errorCode === "DISCOUNT_CODE_MAX_USAGES" ||
                     errorCode === "DISCOUNT_CODE_ALREADY_USED") {
            vm.showError(
              vm.$t("payment.errors.invalidCode"),
              vm.$t("payment.errors.discountCodeUsed")
            );
            vm.invalidDiscountCode = true;
          } else if (
            errorCode === "PACKAGES_NOT_FOUND" ||
            errorCode === "GENERAL_PACKAGES_NOT_FOUND" ||
            errorCode === "ERROR_NOT_PACKAGES_FOUND" ||
            errorCode === "ERROR_UPDATING_PAYMENT" ||
            errorCode === "PAYMENT_NOT_FOUND" ||
            errorCode === "ERROR_PAYMENT_COMPLETED" ||
            errorCode === "ERROR_UNSUPPORTED_PAYMENT_METHOD"
          ) {
            vm.showError("Error", vm.$t("payment.errors.errorUpdating"));
          }
          vm.fetchUserPayment();
        });
    },
    showError(title, description) {
      this.$bvToast.toast(title, {
        title: description,
        variant: "warning",
        solid: true,
      });
    },
    removeListingPackage(id) {
      if (this.packagesListings.length > 1 && this.disablePayment === false) {
        this.packagesListings = this.packagesListings.filter(function (
          packageListing
        ) {
          return packageListing.id !== id;
        });
        this.updateUserPayment(true, this.activePaymentMethod);
      }
    },
    removeGeneralPackage(id) {
      if (this.packagesGeneral.length > 1 && this.disablePayment === false) {
        this.packagesGeneral = this.packagesGeneral.filter(function (packageGeneral) {
          return packageGeneral.id !== id;
        });
        this.updateUserPayment(true, this.activePaymentMethod);
      }
    },
    checkDisabledPayments() {
      var vm = this;
      for (const listingPackage of  vm.packagesListings) {
        const paymentsNotAllowed = listingPackage.packages_detail.package.payment_methods_not_allowed;
        for (const paymentNotAllowed of paymentsNotAllowed) {
          if(vm.disablePayments.indexOf(paymentNotAllowed) === -1){
            vm.disablePayments.push(paymentNotAllowed);
          }
        }
      }
    },
    tabActive(paymentMethod) {
      if (this.loading) return;
      switch (paymentMethod) {
        case this.card_payment:
          this.showTextInSummary = this.$t('payment.viaOnlineBank');
          this.activePaymentMethod = paymentMethod;
          this.updateUserPayment(false, this.activePaymentMethod);
          break;
        case this.banking_payment:
          this.showTextInSummary = this.$t('payment.viaCreditCard');
          this.activePaymentMethod = paymentMethod;
          this.updateUserPayment(false, this.activePaymentMethod);
          break;
        case this.bill_payment:
        case this.true_money:
        case this.prompt_pay:
          this.showTextInSummary = this.$t('payment.viaCreditCard');
          this.activePaymentMethod = paymentMethod;
          this.updateUserPayment(false, this.activePaymentMethod);
          break;
        case this.paypal_payment:
          this.showTextInSummary = this.$t('payment.via')+" Paypal";
          this.activePaymentMethod = paymentMethod;
          this.updateUserPayment(false, this.activePaymentMethod);
          break;
        case this.coin_payment:
          this.showTextInSummary = this.$t('payment.viaCreditCard');
          this.activePaymentMethod = paymentMethod;
          this.updateUserPayment(false, this.activePaymentMethod);
          break;
      }
    },
    selectPaymentMethod(name) {
      this.choosePaymentMethod = name;
    },
    showPaymentDetail() {
      this.isShowPaymentDetail = true;
    },
    goToCheckout() {
      this.isCheckout = true;
    },
    getFooterAds(locationId){
			console.log("locationId",locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				console.log("data",data)
			if (data) {
				this.adsFooter = data;
				this.$forceUpdate();
			}
			});
		},
	},
	destroyed(){
		console.log("destroyed search")
		this.adsFooter=null
	}
};
</script>
<style lang="scss">
@import "style";
.btn-discount-code {
  color: white;
  border-color: white;
  border-radius: var(--borderRadius);
  width: 120px;
  background-color: var(--projectPrimaryColor);
  &:focus {
    color: white;
    background-color: var(--projectPrimaryColor) !important;
    border-color: var(--projectPrimaryColor) !important;
    box-shadow:0 0 0 0.2rem white !important;
  }
  &:hover{
    color: white;
     background-color: var(--projectPrimaryColor) !important;
    border-color: var(--projectPrimaryColor) !important;
    box-shadow:0 0 0 0.2rem white !important;
  }
}
.input-discount-code {
  border-radius: var(--borderRadius);
}
</style>